import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";
import { queryKeys } from "../lib/queryKeys";
import { getApiErrorMessage } from "../lib/apiErrors";

export function useAdminOrganizations() {
  return useQuery({
    queryKey: queryKeys.profile.adminOrganizations(),
    queryFn: async () => {
      const response = await apiService.getAdminOrganizations();
      if (!response.success) {
        throw new Error(getApiErrorMessage(response, "Failed to fetch admin organizations"));
      }
      return response.data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useIsAdminInAnyOrg() {
  const { data: adminOrgs, isLoading } = useAdminOrganizations();
  return {
    isAdminInAnyOrg: (adminOrgs?.length ?? 0) > 0,
    isLoading,
    adminOrgsCount: adminOrgs?.length ?? 0,
  };
}
